import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  border-radius: ${({ theme }) => theme.rounded.x3};
  overflow: hidden;
  width: max-content;
  margin: 0 auto;
`;

export const Step = styled.div<{ $active: boolean; $isPassed; $index; $isLTR: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  padding-inline-start: ${({ theme }) => theme.spacing.x5};
  height: ${({ theme }) => theme.spacing.x10};
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 500;
  position: relative;
  text-align: center;

  ${({ $active, $isPassed, $index, theme, $isLTR }) => {
    const color = $active ? theme.palette.secondaryLightest : $isPassed ? theme.palette.secondary : theme.palette.white;
    return css`
      z-index: ${10 - $index};
      background-color: ${color};
      ${color !== theme.palette.white
        ? css`
            &:after {
              content: '';
              width: 0;
              height: 0;
              border: 20px solid transparent;
              border-inline-start-color: ${color};
              position: absolute;
              z-index: 10;
            }
          `
        : css`
            &:before {
              content: '';
              width: ${({ theme }) => theme.spacing.x6};
              height: ${({ theme }) => theme.spacing.x6};
              background: transparent;
              border: 1px solid ${theme.palette.secondaryLightest};
              position: absolute;
              z-index: 9;
            }
          `};
      ${$isLTR
        ? css`
            &:after {
              right: 0;
              transform: translateX(40px) scaleY(1.5);
            }
            &:before {
              border-width: 1px 1px 0 0;
              right: 0;
              transform: translateX(10px) rotate(45deg);
            }
          `
        : css`
            &:after {
              left: 0;
              transform: translateX(-40px) scaleY(1.5);
            }
            &:before {
              border-width: 0 0 1px 1px;
              left: 0;
              transform: translateX(-10px) rotate(45deg);
            }
          `};
    `;
  }}
`;
